export const SHOW_SPOOF_LAUNCHPAD_COOKIE_NAME = 'show_spoof_launchpad'

export function setShowSpoofLaunchpadCookie(value: boolean) {
  document.cookie = `${SHOW_SPOOF_LAUNCHPAD_COOKIE_NAME}=${(value ? 'on' : 'off')}; expires=Fri, 29 Dec 2028 23:59:59 GMT; path=/;`
}
